<template>
  <div class="setting-main-container" v-if="getBusinessPermission || userType=='super_admin'">
    <div class="card setting-card">
      <div class="page-header">
        <h3 class="page-title">{{ $t('profile.financial_facilities.financial_facilities') }}</h3>
      </div>
      <table-component
        ref="financialFacilityTable"
        :show-filter="false"
        :data="financialFacilities"
        table-class="table tax-table"
        class="mb-3"
      >
        <table-column
          :sortable="true"
          :label="$t('profile.financial_facilities.s_no')"
          show="s_no"
        />
        <table-column
          :label="$t('profile.financial_facilities.amount')"
          show="amount"
        >
          <template slot-scope="row">
            <span> {{ $t('profile.financial_facilities.amount') }} </span>
              <div v-html="$utils.formatMoney(row.amount, defaultCurrency)" />
          </template>
        </table-column>
        <table-column
          :sortable="true"
          :label="$t('profile.financial_facilities.facility_nature')"
          show="facility_nature"
        />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span>{{ $t('profile.financial_facilities.action') }}</span>
            <v-dropdown>
              <a slot="activator" href="#"><dot-icon /></a>
              <v-dropdown-item>
                <div class="dropdown-item" @click="viewFinancialFacility(row)">
                  <font-awesome-icon :icon="['fas', 'eye']" class="dropdown-item-icon" />
                  {{ $t('general.view') }}
                </div>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      isLoading: false,
      userType:null,
    }
  },
computed: {
   ...mapGetters('financialFacility', [
      'financialFacilities'
    ]),
     ...mapGetters('currency', [
      'defaultCurrency'
    ]),
     ...mapGetters('business', [
      'business' ,
      'getBusinessPermission',
    ]),

  },
  watch: {},
  validations: {},
  mounted () {},
  created() {
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    this.checkBusinessPermission();
    this.getFinancialFacility();
  },

  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('financialFacility', [
      'fetchFinancialFacilityByUser'
    ]),
    getFinancialFacility(){
      let data ={
        user_id:this.$route.params.id
      }
      let res =  this.fetchFinancialFacilityByUser(data)
    },
    viewFinancialFacility(data){
       this.openModal({
        'title': 'View Financial Facility',
        'componentName': 'ViewFinancialFacilityModal',
        'id': data.id,
        'data': data
      })
      this.$refs.financialFacilityTable.refresh()
    },
     ...mapActions('business', [
      'BusinessPermission',
      'falseBusinessPermission'
    ]),
    checkBusinessPermission(){
      this.BusinessPermission(this.$route.params.id)
    }
  }
}
</script>
